import { useEffect, useState } from 'react';
import { constants, BigNumber, utils } from 'ethers';
import { Methods, ContractNames } from '@airdao/bond-periphery';

import useBondPeripheryContracts from '../contexts/BondPeripheryContext/useBondPeriphery';
import { RewardsStateProps } from './types';
import { useAccount } from 'wagmi';
import { useEthersAdapter } from '@airdao/ui-library';

const defaultRewardsData = {
  totalReward: BigInt(0),
  getTier: {
    level: BigNumber.from('0x00'),
    minStaked: BigNumber.from('0x00'),
  },
  getDiscount: '0',
};

const useGetMyRewards = () => {
  const contracts: any = useBondPeripheryContracts();
  const { address: account } = useAccount();
  const { provider } = useEthersAdapter();

  const [data, setData] = useState<RewardsStateProps>(defaultRewardsData);

  useEffect(() => {
    (async () => {
      if (account && contracts) {
        try {
          const stakingToken = contracts.getContractByName(
            ContractNames.StakingToken,
          );
          const rewardVault = contracts.getContractByName(
            ContractNames.RewardVault,
          );

          const [totalReward, getTier, getDiscount] = await Promise.all([
            rewardVault.getUserClaimData(account)
              .then((res: { available: BigNumber }) => res.available),
            Methods.stakingManagerGetTier(
              contracts,
              ContractNames.TWStakingTierManager,
              stakingToken.address,
              account,
            ),
            Methods.discountFeederGetDiscount(
              contracts,
              ContractNames.DiscountFeeder,
              stakingToken.address,
              account,
            ),
          ]);

          const discountFeeder = contracts.getContractByName(
            ContractNames.DiscountFeeder,
          );
          const decimals = await discountFeeder.decimals();
          setData(prevState => ({
            ...prevState,
            totalReward,
            getTier,
            getDiscount: utils.formatUnits(getDiscount, decimals - 2),
          }));
        } catch (error) {
          console.error('An error occurred:', error);
        }
      }
    })();
  }, [account, contracts, setData, provider]);

  return data;
};

export default useGetMyRewards;
